<script>
import { addMonths, isBefore, parseISO } from 'date-fns';

export default {
  name: 'CardsListItemContrat',
  props: {
    ligne: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isContratFutur () {
      if (this.ligne.contratFutur === 'Contrats à venir') {
        return true;
      } else {
        return false;
      }
    },
    alerteFinContrat () {
      return isBefore(parseISO(this.ligne.dateFin), addMonths(Date.now(), 1)) && this.ligne.qteRestante > 0;
    }
  }
};
</script>
<template>
  <div class="list-ligne">
    <div class="list-ligne-content">
      <div>
        <strong class="avoidwrap">{{ ligne.libelleTypecontrat }}</strong>
        <strong class="avoidwrap pl-1">
          <span class="d-inline-block ml-2" />
          <span v-if="ligne.codeTContrat === 'EA' && ligne.numFormule === 2">TAF</span>
          {{ ligne.libelleArticle }}
        </strong>
        <sub class="num-article">{{ ligne.numArticle }}</sub>
        <span
          v-if="alerteFinContrat && !isContratFutur"
          class="pl-2"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                color="warning"
                v-on="on"
              >mdi-alert-circle</v-icon>
            </template>
            <span>Il vous reste {{ ligne.qteRestante | formatDecimal(2) }} t à consommer sur votre contrat, ce dernier expire dans moins d'un mois.</span>
          </v-tooltip>
        </span>
      </div>

      <div class="actions-container">
        <slot
          name="actions"
          :ligne="ligne"
        />
      </div>
    </div>

    <div>
      <div class="secondary--text">
        Contrat {{ ligne.numContrat }}
      </div>
      <div v-if="!isMobile || isContratFutur">
        Validité du {{ ligne.dateDebut | date }} au {{ ligne.dateFin | date }}
      </div>
      <div v-if="isMobile && !isContratFutur">
        Valide jusqu'au {{ ligne.dateFin | date }}
      </div>
      <div
        v-if="ligne.codeTContrat !== 'EA'"
        class="primary--text no-wrap"
      >
        <div v-if="ligne.qteContrat">
          Quantité contrat : {{ ligne.qteContrat | formatDecimal(2) }} t
        </div>
      </div>
      <div
        v-if="ligne.codeTContrat ==='EA'"
        class="primary--text no-wrap"
      >
        <div v-if="ligne.qteContrat">
          Quantité réelle apportée : {{ ligne.qteContrat | formatDecimal(2) }} t
        </div>
      </div>

      <div
        v-if="((ligne.qteRestante || ligne.qteRestante === 0) && !isContratFutur)"
        class="primary--text"
      >
        Reste à consommer : {{ ligne.qteRestante | formatDecimal(2) }} t
        <v-tooltip
          v-if="ligne.qteRestante === 0"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              color="warning"
              v-on="on"
            >
              mdi-alert-circle
            </v-icon>
          </template>
          <span>Contrat soldé. L'article peut toujours être commandé au prix du jour.</span>
        </v-tooltip>
      </div>
      <div
        v-if="ligne.numLot"
        class="primary--text"
      >
        Lot : {{ ligne.numLot }} <span class="d-inline-block ml-2" /> Batiment : {{ ligne.numBatiment }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.list-ligne {
  padding: 0.5em 1em;
}
.list-ligne-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
  & > *:first-child {
    flex-grow: 1;
  }
  & > *:not(:first-child) {
    margin-left: 1em;
  }
}
</style>
